import withApp from '@/components/withApp';
import CampaignPage from './CampaignPage';
import getInitialProps from './getInitialProps';

const CampaignPageWithApp = withApp(CampaignPage);

CampaignPageWithApp.getInitialProps = getInitialProps;

export default CampaignPageWithApp;
